import React from 'react';
import Component from 'components/component';

import RuptlyPass from './ruptly-pass'
import Enterprise from './enterprise'
import RuptlyPassUnaprooved from './ruptly-pass-unaprooved';

function getComponent(plan) {
    switch (plan.agreement_type) {
        case 'ruptly_pass': {
            if (plan.status === 'unapproved') {
                return RuptlyPassUnaprooved
            } else {
                return RuptlyPass;
            }
        }
        default: {
            return Enterprise;
        }
    }
}

export default class AgreementDescription extends Component {

    render() {
        const Component = getComponent(this.props.data);

        return (
            <Component {...this.props}/>
        );
    }
}